var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAbcboard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20262 -1865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20262 1865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20253.324 1871.073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4535.834,3427.231q-3.86,0-7.721,0a1.4,1.4,0,0,1-1.463-.9,1.544,1.544,0,0,1,.2-1.546,19.564,19.564,0,0,0,1.444-2.246,8.872,8.872,0,0,0,.9-4.139,10.228,10.228,0,0,1,.512-3.739,6.777,6.777,0,0,1,3.992-4.163c.835-.324.843-.3.864-1.28a1.33,1.33,0,0,1,1.278-1.369,1.352,1.352,0,0,1,1.316,1.337c.018.34-.058.761.094,1,.139.214.534.211.806.329a7.059,7.059,0,0,1,4.278,5.488,10.985,10.985,0,0,1,.161,2.1,9.57,9.57,0,0,0,2.012,6.194c.1.123.173.27.271.392a1.558,1.558,0,0,1,.277,1.643,1.35,1.35,0,0,1-1.312.9c-.617.023-1.237.007-1.855.007Zm1.039-10.816h0c0-.7.008-1.409,0-2.113-.013-.767-.385-1.235-.975-1.256-.642-.022-1.085.431-1.1,1.214-.023,1.435-.014,2.872,0,4.308a1.221,1.221,0,0,0,.44,1c.713.542,1.588.056,1.628-.921C-4534.771,3417.908-4534.795,3417.161-4534.795,3416.416Zm-1.032,7.842a1.358,1.358,0,0,0,1.377-1.477,1.367,1.367,0,0,0-1.34-1.518,1.346,1.346,0,0,0-1.392,1.5A1.345,1.345,0,0,0-4535.827,3424.258Z",
    transform: "translate(4545.142 -3407.85)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4448.919,3660.133a2.8,2.8,0,0,1-1.353,2.426,2.75,2.75,0,0,1-3.164.006,2.709,2.709,0,0,1-1.346-2.432Z",
    transform: "translate(4461.183 -3639.208)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbcboard2);
export default __webpack_public_path__ + "static/media/icon-abcboard-2.d7a02b68.svg";
export { ForwardRef as ReactComponent };